import React from 'react';
import Box from '@mui/material/Box';
import WorkerNavBar from '../../Components/NavigationBar/WorkerNavBar';
import WorkerDeviceDetails from '../../Components/Worker/WorkerDeviceDetails';

function WorkerDevice() {
  return (
    <WorkerNavBar>
      <Box sx={{ width: '100%' }}>
        <WorkerDeviceDetails />
      </Box>
    </WorkerNavBar>
  );
}

export default WorkerDevice;